import { useContext } from 'react';
import { Formik, Form } from 'formik' 
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { formatError, logError } from '../services/logging';
import { UserContext } from "../context/UserContext";
import Button from '../components/Button'
import EmailInput from '../components/Forms/EmailInput';
import PasswordInput from '../components/Forms/PasswordInput';
import PassConfirmInput from '../components/Forms/PassConfirmInput';
import { API_URL } from '../config/api';
import '../styles/auth.css';
import '../styles/profile.css';

const initialValues = {
    email: '',
    password: '',
    passwordConfirm: '',
};

const validationSchema = Yup.object({
    email: Yup.string()
        .email("Invalid email address"),
    password: Yup.string()
        .min(8, "Password must be at least 8 characters"),
    passwordConfirm: Yup.string()
        .oneOf([Yup.ref('password'), null], "Passwords must match"),
});

const EditProfile = ({ handleClick }) => {
      const { logOutUser } = useContext(UserContext);
    
  return (
    <section className="edit-container">
        <h3>Edit Profile</h3>
        <p>Update your profile information below.</p>

        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={async (values, { setSubmitting }) => {
                try {
                    const resp = await fetch(`${API_URL}/api/profile`, {
                        method: "PATCH",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        credentials: "include",
                        body: JSON.stringify(values)
                    })

                    const data = await resp.json()

                    if (resp.ok) {
                        toast.success("Profile updated successfully.")
                    } else {
                        logError(data)
                        toast.error(data.message || "Profile update failed.")
                    }
                } catch (error) {
                    logError(formatError(error))
                    toast.error("An unexpected error occurred. Please try again.")
                } finally {
                    setSubmitting(false)
                    handleClick()
                }
            }}
        >
            {({ errors, touched, dirty, isValid, isSubmitting }) => (
                <Form>
                    <EmailInput errors={errors} touched={touched} />
                    <PasswordInput errors={errors} touched={touched} />
                    <PassConfirmInput errors={errors} touched={touched} />

                    <Button 
                        variant="primary" 
                        text="Save changes" 
                        type="submit" 
                        disabled={!dirty || !isValid || isSubmitting}
                    />
                    <Button 
                        variant="secondary" 
                        text="Cancel" 
                        type="button" 
                        handleClick={handleClick}
                    />

                    <Button variant="link" text="Log out" type="button" handleClick={logOutUser}/>
                </Form>
            )}
        </Formik>
    </section>
  )
}

export default EditProfile